<template>
  <div class="article_detail">
    <h2 class="title">{{ article.title }}</h2>
    <p class="release_time" v-show="article.datatime">发布时间: {{ formatDate(article.datatime) }}</p>
    <div class="main">
      <div class="content" v-html="article.cont"></div>
    </div>
  </div>
</template>

<script>
import { apiData } from '@/api'
import { formatDate } from '@/utils/common'
export default {
  name: 'ArticleDetail',
  data() {
    return {
      article: {
        datatime: '',
        title: '',
        cont: '',
        type: ''
      }
    }
  },
  created() {
    this.getArticleDetail()
  },
  methods: {
    formatDate,
    async getArticleDetail() {
      const { id } = this.$route.query
      const res = await apiData.queryArticleDetail(id)
      console.log('res', res)
      this.article = res.data
    }
  }
}
</script>

<style lang="less" scoped>
.article_detail {
  .title {
    text-align: center;
  }

  .release_time {
    text-align: center;
  }

  .main {
    padding: 10px 30px;

    .content {}
  }

}
</style>
